import { Stack, Paper, Group, Text, Badge, Code, Title, Anchor } from "@mantine/core";
import { IconKey, IconBriefcase } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../auth/AuthContext";
import { TesterPanel } from "./invoiceApi/TesterPanel";

/**
 * The "Invoice API" tab in the gr-invoice-automation module. Documents the
 * two inbound webhook endpoints and exposes the in-app tester. Received
 * invoices are reviewed in the separate AP Workbench module.
 */
export function InvoiceApiTab() {
  const { user } = useAuth();
  const hasWorkbench =
    user?.isAdmin || !!user?.modulePermissions?.["ap-workbench"];

  return (
    <Stack gap="md">
      <Paper p="md">
        <Stack gap="xs">
          <Group justify="space-between" wrap="wrap" align="flex-start">
            <div>
              <Title order={4}>Inbound webhooks</Title>
              <Text size="sm" c="dimmed">
                Duvo POSTs AP invoices to these endpoints. Authentication is by
                API key only (issued in Administration {">"} API Keys).
              </Text>
            </div>
            {hasWorkbench && (
              <Anchor
                component={Link}
                to="/modules/ap-workbench"
                size="sm"
                style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
              >
                <IconBriefcase size={14} /> Open AP Workbench
              </Anchor>
            )}
          </Group>
          <EndpointRow
            method="POST"
            path="/api/modules/gr-invoice-automation/inbound/full"
            label="Full (matched)"
          />
          <EndpointRow
            method="POST"
            path="/api/modules/gr-invoice-automation/inbound/mismatched"
            label="Mismatched"
          />
          <Group gap="xs">
            <IconKey size={14} />
            <Text size="xs" c="dimmed">
              Required header:
            </Text>
            <Code>X-API-Key: dmw_xxxxxxxx_xxxxxxxxxxxxxxxx</Code>
          </Group>
        </Stack>
      </Paper>

      <TesterPanel />
    </Stack>
  );
}

function EndpointRow({ method, path, label }) {
  return (
    <Group gap="xs" wrap="nowrap">
      <Badge color="green" variant="filled" size="sm" w={64}>
        {method}
      </Badge>
      <Code style={{ flex: 1 }}>{path}</Code>
      <Badge variant="light" color="indigo" size="sm">
        {label}
      </Badge>
    </Group>
  );
}
